import { call, put, delay } from 'redux-saga/effects';

import { getUsersToSendTo } from '@api/messages';
import {
  recipientsGetSuccessAction,
  recipientsGetFailureAction,
} from '@store/messages/recipients/recipients.actions';
import { toastError } from '@store/notifications';

export const handleGetRecipients = function* ({ payload = {} }) {
  try {
    // debounce
    if (payload.isSearch) {
      yield delay(200);
    }

    const response = yield call(getUsersToSendTo, payload);

    yield put(recipientsGetSuccessAction(response));
  } catch (error) {
    yield put([
      toastError({
        id: 'get-users-to-send-to-error',
        message: error.data?.nonFieldErrors || {
          defaultMessage: 'An unexpected error occurred, please try again.',
          id: 'global.notification.api-error-default',
        },
      }),
      recipientsGetFailureAction(),
    ]);
  }
};
